import { Button } from '@heroui/button'
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/modal'

interface CancelModalProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  title: React.ReactNode
  description: React.ReactNode
  cancelButtonTitle: string
  action: {
    title: string
    onClick: () => void
  }
}

const CancelModal = ({
  isOpen,
  onOpenChange,
  action,
  title,
  description,
}: CancelModalProps) => {
  return (
    <Modal
      placement="center"
      size="xs"
      radius="lg"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      hideCloseButton
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="pb-0 pt-6 font-crimsonPro text-2xl font-normal">
              {title}
            </ModalHeader>
            <ModalBody className="text-xs font-light leading-normal text-content4-foreground">
              {description}
            </ModalBody>
            <ModalFooter className="flex justify-end gap-2 pb-6">
              <Button
                color="primary"
                variant="light"
                radius="full"
                size="lg"
                onPress={onClose}
                className="w-[120px]"
              >
                Cancel
              </Button>
              <Button
                color="danger"
                radius="full"
                size="lg"
                onPress={action.onClick}
                className="w-[120px]"
              >
                {action.title}
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default CancelModal
